import { Nullable } from '../../utils';

export enum AppStatus {
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
  Deleted = 'DELETED',
}

export enum TargetStatus {
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
  Deleted = 'DELETED',
}

export enum MessageActionType {
  None = 'NONE',
  Append = 'APPEND',
  Prepend = 'PREPEND',
}

export enum CommunicationType {
  Marketing = 'MARKETING',
  Transactional = 'TRANSACTIONAL',
  Both = 'BOTH',
}

export enum SenderType {
  LongCode = 'LONG_CODE',
  ShortCode = 'SHORT_CODE',
}

export interface AppModel {
  appId: string;
  name: string;
  code: string;
  twilioAccountId: Nullable<string>;
  defaultCountryCode: string;
  defaultSMSSender: Nullable<string>;
  defaultEmailSender: Nullable<string>;
  defaultSenderType: Nullable<SenderType>;
  defaultVoiceNumber: Nullable<string>;
  optInMessage: Nullable<string>;
  helpMessage: Nullable<string>;
  optOutMessage: Nullable<string>;
  startMessage: Nullable<string>;
  status: AppStatus;
  targets: TargetModel[];
  scopes: ScopeModel[];
  appChannels: AppChannelModel[];
  sendgridPromotionalAsmGroupId?: number;
  sendgridTransactionalAsmGroupId?: number;
  twilioSmsOutboundStatusCallbackUrl?: string;
  twilioSmsInboundStatusCallbackUrl?: string;
  twilioEventStreamSinkUrl?: string;
  sendgridEmailWebhookUrl?: string;
}

export interface TargetModel {
  appId: string;
  targetId: string;
  name: string;
  forwardUrl: string;
  forwardMethod: ForwardMethod;
  authHeaders: TargetAuthHeader[];
  status: TargetStatus;
  scopes?: ScopeModel[];
  message?: string;
  messageActionType: MessageActionType;
}

export interface TargetAuthHeader {
  targetAuthHeaderId?: string;
  name: string;
  value: string;
}

export interface ScopeModel {
  appId: string;
  scopeId: string;
  name: string;
  keyword: string;
  byPassOptIn: boolean;
  doubleOptIn: boolean;
  doubleOptInMsg: string;
  doubleOptInAcceptOptions: string;
  doubleOptInRejectOptions: string;
  targets?: TargetModel[];
}

export interface AppChannelModel {
  channel: AppChannel;
}

export enum AppChannel {
  Email = 'EMAIL',
  Voice = 'VOICE',
  Push = 'PUSH',
  Sms = 'SMS',
}

export enum ForwardMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
}

export enum ApiKeyType {
  PrimaryKey = 'PrimaryKey',
  SecondaryKey = 'SecondaryKey',
}
